import * as stylex from '@stylexjs/stylex';
import { forwardRef } from 'react';
import { Icon, type IconProps } from '../IconShell';
import { iconsStyles } from '../styles';
export const PaperAeroplane = forwardRef<SVGSVGElement, Partial<IconProps>>(function PaperAeroplane({
  styles,
  ...props
}, ref) {
  return <Icon title="Paper Aeroplane" description="A paper aeroplane icon to depict direct mail postage" ref={ref} {...stylex.props(styles)} viewBox="0 0 36 36" {...props}>
        <path {...stylex.props(iconsStyles.lightElement)} d="M12.53 33.65C10.76 29.77 10.96 21 10.96 21L30.29 6.01c-.54 5.32-9.1 26.15-17.76 27.64Z" />
        <path {...stylex.props(iconsStyles.lightElement)} d="M4.07 17.27c-.86-.75-.82-1.96.12-2.6 5.2-3.57 19.8-10.8 27.41-12.18 1.22-.23 2.23.76 2.14 2-.54 7.69-3.4 22.36-5.93 27.31-.44.86-1.47 1.04-2.3.56a152.13 152.13 0 0 1-12.1-7.94c-5.14-3.66-7.9-5.9-9.34-7.15Z" />
        <path {...stylex.props(iconsStyles.darkElement)} d="M30.18 6c-.75-.75-18.2 13.44-19.6 16.37 0 0-.06 10.97 1.95 11.28 1.09 0 3.09-5.77 3.5-7.03.06-.16.13-.3.24-.43C20.65 20.43 30.92 6.74 30.17 6Z" />
      </Icon>;
});